import baseRoute from '../baseRoute';

export default `${baseRoute}/organizationContact` as const;
